// ✅ Homepage Every Way Swiper
if (document.querySelector('.homepage-every-way-swiper')) {
  const homepageEveryWaySwiper = new Swiper('.homepage-every-way-swiper', {
    pagination: {
      el: '.homepage-every-way-pagination-button .homepage-every-way-swiper-pagination'
    },
    navigation: {
      nextEl: '.homepage-every-way-pagination-button .swiper-button-next',
      prevEl: '.homepage-every-way-pagination-button .swiper-button-prev'
    },
    scrollbar: {
      el: ".homepage-every-way-swiper-scrollbar",
      hide: true
    },
    breakpoints: {
      320: { slidesPerView: 1.26, spaceBetween: 8 },
      490: { slidesPerView: 1.6, spaceBetween: 8 },
      600: { slidesPerView: 2, spaceBetween: 8 },
      768: { slidesPerView: 2.3, spaceBetween: 8 },
      890: { slidesPerView: 2.7, spaceBetween: 8 },
      992: { slidesPerView: 4, spaceBetween: 24 }
    }
  });
}

// ✅ Homepage Other Page Swiper
if (document.querySelector('.homepage-other-page-swiper')) {
  const homepageOtherPageSwiper = new Swiper('.homepage-other-page-swiper', {
    breakpoints: {
      320: { slidesPerView: 2, initialSlide: 1, centeredSlides: true, spaceBetween: 15 },
      576: { slidesPerView: 2.8, initialSlide: 1, centeredSlides: true, spaceBetween: 15 },
      768: { slidesPerView: 3, initialSlide: 1, centeredSlides: true, spaceBetween: 15 },
      992: { slidesPerView: 3, centeredSlides: false, spaceBetween: 24 }
    }
  });
}

// ✅ Homepage Organization Swiper
if (document.querySelector('.homepage-organization-swiper')) {
  const homepageOrganizationSwiper = new Swiper('.homepage-organization-swiper', {
    slidesPerView: 1,
    pagination: {
      el: '.homepage-organization-pagination-button .homepage-organization-swiper-pagination'
    },
    navigation: {
      nextEl: '.homepage-organization-pagination-button .swiper-button-next',
      prevEl: '.homepage-organization-pagination-button .swiper-button-prev'
    }
  });
}

// ✅ Homepage Video Play Button
const videoBtn = document.querySelector('#video_btn');
if (videoBtn) {
  videoBtn.addEventListener("click", () => {
    const video = document.querySelector('#video-wrapper video');
    video.play();
    video.setAttribute('controls', true);
    document.querySelector('.homepage-video-container').style.display = 'none';
  });
}

// ✅ Homepage USP Popup
const openUspPopup = (id) => {
  document.querySelector(`.homepage-usp-popup-overlay`).classList.add('active');
  document.querySelector(`#homepage-usp-popup-${id} .homepage-usp-popup-container`).classList.add('active');
  document.body.classList.add('scroll-disable');
};
const closeUspPopup = (id) => {
  document.querySelector(`.homepage-usp-popup-overlay`).classList.remove('active');
  document.querySelector(`#homepage-usp-popup-${id} .homepage-usp-popup-container`).classList.remove('active');
  document.body.classList.remove('scroll-disable');
};
const uspOverlay = document.querySelector('.homepage-usp-popup-overlay');
if (uspOverlay) {
  uspOverlay.addEventListener('click', () => {
    [1, 2, 3, 4].forEach(closeUspPopup);
  });
}

// ✅ Extend Product USP
const extendProductUsp = (id) => {
  const element = document.querySelectorAll('.homepage-offers-container .homepage-offers-product')[+id];
  element.querySelector('.homepage-offers-product-usps').classList.toggle('hidden');
  element.querySelector('.homepage-offers-product-usps-extended').classList.toggle('hidden');
};

// ✅ Toggle Accessories
const toggleAccessories = (element) => {
  const span = element.querySelector('span');
  const parent = element.parentNode.parentNode;
  if (span.innerHTML === 'See All') {
    span.innerHTML = 'See Less';
    parent.classList.remove('hidden');
  } else {
    span.innerHTML = 'See All';
    parent.classList.add('hidden');
  }
};

// ✅ Homepage Review Video Popup
const playVideo = (id) => {
  const element = document.querySelectorAll('.homepage-review-video-popup')[+id];
  const video = element.querySelector('.homepage-review-video video');
  video.play();
  video.setAttribute('controls', true);
  element.querySelector('.homepage-review-video-button').style.display = 'none';
};

const openVideoPopup = (id) => {
  document.querySelectorAll('.homepage-review-video-popup')[+id].classList.add('active');
};

const closeVideoPopup = (id) => {
  const element = document.querySelectorAll('.homepage-review-video-popup')[+id];
  const video = element.querySelector('.homepage-review-video video');
  element.classList.remove('active');
  video.pause();
  video.setAttribute('controls', false);
  element.querySelector('.homepage-review-video-button').style.display = 'flex';
};
